import React from "react";

export const Pagination = ({ page, total, pageSize, onPage, testid }) => {
  const pages = Math.max(1, Math.ceil(total / pageSize));
  if (total <= pageSize) return null;
  return (
    <div className="flex items-center justify-between mt-4 text-sm" data-testid={testid}>
      <span className="text-[#8A9A86]">Page {page} of {pages} · {total} total</span>
      <div className="flex gap-2">
        <button disabled={page <= 1} onClick={() => onPage(page - 1)} data-testid={`${testid}-prev`} className="btn-secondary text-xs py-1.5 px-3 disabled:opacity-40 disabled:cursor-not-allowed">Prev</button>
        <button disabled={page >= pages} onClick={() => onPage(page + 1)} data-testid={`${testid}-next`} className="btn-secondary text-xs py-1.5 px-3 disabled:opacity-40 disabled:cursor-not-allowed">Next</button>
      </div>
    </div>
  );
};
